import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetReservoirTypeRequest, GetReservoirTypeResponse } from './types/TReservoirTypeServices';

const URL_Prefix = '/reservoir_type';

export const reservoirService = createApi({
    reducerPath: 'reservoirService',
    baseQuery: getBaseQuery,
    tagTypes: ['Reservoir'],
    endpoints: (builder) => ({
        getReservoir: builder.query<GetReservoirTypeResponse, GetReservoirTypeRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/selector/`,
                method: 'GET',
            }),
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetReservoirQuery,
    useLazyGetReservoirQuery
} = reservoirService;